import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { LogoutComponent } from './logout.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
    imports: [CommonModule, RouterModule, SharedModule],
    declarations: [LoginComponent, LogoutComponent],
    exports: [LoginComponent, LogoutComponent]
})
export class LoginModule { }
